"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clamp = exports.percentage = void 0;
/**
 * Gets the percentage difference between two numbers.
 * @param {number} x The first number.
 * @param {number} y The second number.
 * @returns {number} The percentage between the numbers.
 */
var percentage = function (x, y) {
    return (Math.abs(x - y) / ((x + y) / 2)) * 100;
};
exports.percentage = percentage;
/**
 * Clamps a value within a certain number range.
 * @param {number} val The value to clamp.
 * @param {number} min The minimum value.
 * @param {number} max The maximum value.
 * @returns {number} The clamped number.
 */
var clamp = function (val, min, max) {
    return Math.max(min, Math.min(val, max));
};
exports.clamp = clamp;
//# sourceMappingURL=math.js.map